// extracted by mini-css-extract-plugin
export default {"listCustom":"SettingNotification_listCustom__fLlUv"};